// Header.js (patched)
import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Header.css';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  const isAdminLogged = !!localStorage.getItem('TKS_ADMIN_TOKEN');

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setIsDropdownOpen(false);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const hash = window.location.hash.slice(1);
    if (hash && location.pathname === '/') {
      setTimeout(() => {
        const element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 0);
    }
  }, [location]);

  const scrollToSection = (sectionId) => {
    closeMenu();
    if (location.pathname === '/') {
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      navigate(`/#${sectionId}`);
    }
  };

  const isActiveLink = (path) => {
    return location.pathname === path;
  };

  const isActiveSection = (sectionId) => {
    return location.pathname === '/' && window.location.hash === `#${sectionId}`;
  };

  return (
    <>
      <header className="header">
        <div className="container">
          <Link to="/" className="logo" onClick={closeMenu}>
            <h1>TKS COURIER & CARGO</h1>
          </Link>
          <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
            <ul className="nav-list">
              <li><Link to="/" className={isActiveLink('/') && !window.location.hash ? 'active' : ''} onClick={() => scrollToSection('home')}>Home</Link></li>

              <li className={`dropdown ${isDropdownOpen ? 'dropdown-open' : ''}`} ref={dropdownRef}>
                <button className="dropdown-toggle" onClick={toggleDropdown}>Company</button>
                <ul className="dropdown-menu">
                  <li><Link to="/why-us" onClick={closeMenu}>Why Us</Link></li>
                  <li><Link to="/testimonials" onClick={closeMenu}>Testimonials</Link></li>
                  <li><button onClick={() => scrollToSection('about')}>About Us</button></li>
                  <li><button onClick={() => scrollToSection('map')}>Location / Map</button></li>
                </ul>
              </li>

              <li><button className={isActiveSection('services') ? 'active' : ''} onClick={() => scrollToSection('services')}>Services</button></li>

              <li><Link to="/booking" className={isActiveLink('/booking') ? 'active' : ''} onClick={closeMenu}>Booking</Link></li>

              <li><Link to="/tracking" className={isActiveLink('/tracking') ? 'active' : ''} onClick={closeMenu}>Tracking</Link></li>

              <li><Link to="/pricing" className={isActiveLink('/pricing') ? 'active' : ''} onClick={closeMenu}>Pricing</Link></li>

              <li><button className={isActiveSection('contact') ? 'active' : ''} onClick={() => scrollToSection('contact')}>Contact</button></li>

              <li>
                {isAdminLogged ? (
                  <Link
                    to="/admin/dashboard"
                    onClick={closeMenu}
                  >
                    Dashboard
                  </Link>
                ) : (
                  <Link
                    to="/admin/login"
                    onClick={closeMenu}
                  >
                    Admin
                  </Link>
                )}
              </li>
            </ul>
          </nav>

          <div className="hamburger" onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </header>

      {isMenuOpen && <div className="nav-overlay" onClick={closeMenu}></div>}
    </>
  );
}

export default Header;
